import { Button, type ButtonProps, type LinkProps } from '@mui/material'
import React from 'react'

import { StyledLink } from 'components/common/StyledLink'

export function MUIExternalLinkButton({
  href,
  ...rest
}: ButtonProps & LinkProps) {
  return (
    <Button
      component={StyledLink}
      href={href}
      rel="noopener noreferrer nofollow"
      target="_blank"
      variant="contained"
      {...rest}
    />
  )
}
